import { data as outlander2026Data } from './data/model/outlander-2026/data'
import { data as outlander2025Data } from './data/model/outlander-2025/data'
import { data as eclipseCross2026Data } from './data/model/eclipse-cross-2026/data'
import { data as rvr2026Data } from './data/model/rvr-2026/data'

export const data = {
  outlander: outlander2026Data,
  'outlander-2025': outlander2025Data,
  'eclipse-cross': eclipseCross2026Data,
  rvr: rvr2026Data,
}
